import {
    LinkAction,
    LinkRegistry
} from "../../models";

import { ExternalReportLinkRegistryFormVariables } from "@tenera/linkregistrymodels";
import QRCodeWithHint from "../qrcode/QRCodeWithHint";

const INGRESS_APP_URL = process.env.REACT_APP_CLIENT_INGRESS_URL || "http://localhost:3001";

export const useLinkRegistryQRCode = () => {

    const getQRCodeForLink = (link: LinkRegistry) => {
        switch (link.action) {
            case LinkAction.EXTERNAL_REPORT:
            case LinkAction.ASSESSMENT_FORM:
                return getQRCodeForExternalReportLink(link);
            case LinkAction.UNASSIGNED:
                return getQRCodeForUnassignedLink(link);
            case LinkAction.ISSUE_FORM:
            default:
                return getBlankQRCode(link);
        }
    };

    const getQRCodeForExternalReportLink = (link: LinkRegistry) => {
        const variables = JSON.parse(link.variables || "") as ExternalReportLinkRegistryFormVariables;
        return (
            <QRCodeWithHint
                qrUrl={`${INGRESS_APP_URL}/redirect/${link.id}`}
                propertyName={variables.propertyAddress || "_______________________"}
                locationName={variables.locationName || "_______________________"}
            />
        );
    };

    const getQRCodeForUnassignedLink = (link: LinkRegistry) => {
        return (
            <QRCodeWithHint
                qrUrl={`${INGRESS_APP_URL}/redirect/${link.id}`}
            />
        );
    };

    const getBlankQRCode = (link: LinkRegistry) => {
        return (
            <QRCodeWithHint
                qrUrl={`${INGRESS_APP_URL}/redirect/${link.id}`}
            />
        );
    };

    return { getQRCodeForLink };
};
